import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type Activity = {
  id: string; kind: "event" | "change" | "status" | "comment" | "system"; verb: string; summary: string;
  actor: { id: string; name: string } | null; data: Record<string, unknown>; created_at: string;
};

const key = (entityType: string, objectId: string) => ["timeline", entityType, objectId];

export function useTimeline(entityType: string, objectId: string | undefined) {
  return useQuery({
    queryKey: key(entityType, objectId ?? ""),
    enabled: !!objectId,
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/audit/timeline/{entity_type}/{object_id}/", {
        params: { path: { entity_type: entityType, object_id: objectId! }, query: { page_size: 100 } },
      });
      if (error) throw new Error(errorMessage(error));
      return (data as unknown as { results: Activity[] }).results;
    },
  });
}

export function useAddComment(entityType: string, objectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (text: string) => {
      const { error } = await api.POST("/api/v1/audit/timeline/{entity_type}/{object_id}/", {
        params: { path: { entity_type: entityType, object_id: objectId } }, body: { text },
      });
      if (error) throw new Error(errorMessage(error));
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: key(entityType, objectId) }),
  });
}
